import { t } from '@lingui/core/macro';
import { IconButton, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDownloadCSV } from './useDownloadCSV';
export function CSVDownload() {
    const { download, loading } = useDownloadCSV();
    const text = t({
        message: 'Download data as a CSV file',
        comment: 'CSV download button: Label',
    });
    return (<IconButton $round onClick={download} disabled={loading} appearance="secondary" aria-label={text}>
      {loading ? <Loader /> : <Falcon icon="download"/>}
    </IconButton>);
}
